define('responsive-gameday/controllers/PitchByPitchMatchupViewController',['require','exports','module','Responsive/controllers/ViewController','./PitchByPitchViewController','./MatchupViewController','Responsive/util/renderComplete','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service'],function(require,exports,module){
    // Add private variables here
    var ViewController = require("Responsive/controllers/ViewController"),
        PitchByPitchViewController = require( './PitchByPitchViewController' ),
        MatchupViewController = require( './MatchupViewController' ),
        renderComplete = require("Responsive/util/renderComplete"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service");

    var renderers = null,
        Superclass;
    
    // Constructor
    function PitchByPitchMatchupViewController(showTeamMatchup) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "pitchbypitchmatchup";
        this.showTeamMatchup=showTeamMatchup;
        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ViewController.spawn(PitchByPitchMatchupViewController).define({
        loadView : function(){
            Superclass.loadView.call(this);
            this.setClassName("PitchByPitchMatchupViewController");
            
            this.matchup=new MatchupViewController(this.showTeamMatchup);
            this.pitchbypitch=new PitchByPitchViewController();
            this.childViewControllers.push(this.matchup);
            this.childViewControllers.push(this.pitchbypitch);
            this.matchup.parentViewController = this;
            this.pitchbypitch.parentViewController = this;
        },
        draw : function(){
            var that=this;
            Superclass.draw.call(this);

            // this.setAvailableHeight();

            that.childViewControllers.forEach(function(vc){
                vc.viewWillAppear();
                that.getView().appendChild(vc.getView());
                vc.viewDidAppear();
            });
            this.checkPbp = function(){
                if(that.pitchbypitch.isViewLoaded() && that.pitchbypitch.setScroll){
                    that.pitchbypitch.setScroll();
                }
            }
            MessageService.addListener.call(that, VMEvents.UPDATE_MATCHUP, that.checkPbp);
        },
        viewWillDisappear : function(){
            Superclass.viewWillDisappear.call(this);
            MessageService.removeListener.call(this, VMEvents.UPDATE_MATCHUP, this.checkPbp);
        }
        // ,
        // viewWillAppear  : function(){
        //     var that = this;
        //     Superclass.viewWillAppear.call(this);
        //     renderComplete(function(){
        //         // HACK HACK HACK HACK
        //         that.offsetView = that.pitchbypitch.view;
        //         that.checkHeight();
        //         // \HACK HACK HACK HACK
        //     });
        // }
    });

    Superclass = PitchByPitchMatchupViewController.superclass;
    return PitchByPitchMatchupViewController;
});
